import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { shouldRenderCompanyTrialBanner as ShouldRenderCompanyTrialBannerQuery } from './types/shouldRenderCompanyTrialBanner';

export const shouldRenderCompanyTrialBannerQuery = gql`
  query shouldRenderCompanyTrialBanner($accountId: Int!) {
    account(id: $accountId) {
      currentUserRole
      id
      isTrialingCompanies
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<ShouldRenderCompanyTrialBannerQuery>(
    shouldRenderCompanyTrialBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
      },
    }
  );

  return Boolean(
    data?.account?.isTrialingCompanies &&
      data?.account?.currentUserRole !== 'member'
  );
};
